import { useEffect, useRef, useState } from "react";

// Ridimensionamento colonne tabella con persistenza in localStorage.
// defaultW: mappa { colKey: larghezzaPx }. Ritorna { colW, startResize, totalW }.
export function useColumnResize(storageKey, defaultW) {
  const [colW, setColW] = useState(() => {
    try { return { ...defaultW, ...JSON.parse(localStorage.getItem(storageKey) || "{}") }; }
    catch { return defaultW; }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, JSON.stringify(colW)); } catch { /* noop */ }
  }, [storageKey, colW]);
  const resizing = useRef(null);
  const startResize = (e, key) => {
    e.stopPropagation(); e.preventDefault();
    resizing.current = { key, startX: e.clientX, startW: colW[key] || defaultW[key] || 120 };
    const onMove = (ev) => {
      if (!resizing.current) return;
      const d = ev.clientX - resizing.current.startX;
      setColW((w) => ({ ...w, [resizing.current.key]: Math.max(50, resizing.current.startW + d) }));
    };
    const onUp = () => { resizing.current = null; window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
    window.addEventListener("mousemove", onMove); window.addEventListener("mouseup", onUp);
  };
  const totalW = Object.keys(defaultW).reduce((s, k) => s + (colW[k] || defaultW[k]), 0);
  return { colW, startResize, totalW };
}
